import { Component, Prop, h, Watch, Element } from '@stencil/core';
import { handleAriaLabelChange } from '../../../shared/aria-utils';

/**
 * In the future, this component should be updated to restrict which icon names can be used:
 * Product icons shouldn't be usable outside of illustrative and contained variants,
 * and illustrative and contained variants should only be able to use product icons.
 */

@Component({
  tag: 'a1-icon',
  styleUrl: '../a1-icon.scss',
  scoped: true,
})
export class a1Icon {
  @Element() host!: HTMLA1IconElement;
  /**
   * Icon type. 'inherit' uses the parent element's font color.
   */
  @Prop({ reflect: true }) type: 'inherit' | 'primary' | 'secondary' = 'inherit';

  /**
   * Icon name.
   */
  @Prop({ reflect: true }) icon: string = 'download';

  /**
   * Icon size. For functional icons: 's' or 'm' is valid
   *
   */
  @Prop({ reflect: true }) size: 's' | 'm' = 'm';

  /**
   * Toggle for enabled / disabled icon appearance.
   */
  @Prop({ reflect: true }) disabled: boolean = false;

  /**
   * An alternate description to use for assistive devices. If omitted, the icon will be considered presentational and ignored by assistive devices.
   */
  @Prop() label: string = '';

  /**
   * When true, displays the icon in inverse colors for use on dark backgrounds.
   */
  @Prop({ reflect: true }) inverse: boolean = false;

  private get classNames() {
    return {
      icon: true,
      functional: true,
      [`c-icon--${this.icon}`]: true,
      [this.type]: true,
      [this.size]: true,
      disabled: this.disabled,
      inverse: this.inverse,
    };
  }
  @Watch('label')
  getAriaLabelChange() {
    handleAriaLabelChange(this.host, this.label);
  }

  componentDidLoad() {
    this.getAriaLabelChange();
  }

  render() {
    return <i class={this.classNames}></i>;
  }
}
